import React, { useEffect, useState } from 'react';
import { Margin } from '@scotia/canvas-react';
import Axios from 'axios';
import Iframe from 'react-iframe';
import PropTypes from 'prop-types';
import { OnlineCourseContainer } from './components/online-course_container.jsx';
import { getToken, getOnlineCurseInfoProvider } from '../../services/service.parameters';

export const OnlineCourse = ({ htmlURL, callback }) => {
  const [availableHTML, isTheHTMLAvailable] = useState(false);

  /**
   * First Call the service to see if the client has an online curse
   * so proceed to show the iframe
   */
  const doesTheClientHasOnlineCurse = async () =>
    new Promise(async (resolve, reject) => {
      Axios.get(await getOnlineCurseInfoProvider(), {
        headers: {
          Authorization: `Bearer ${await getToken({ tokenIntends: 'TRXONC' })}`,
        },
      })
        .then(response => {
          /* istanbul ignore next */
          if (response.data && response.data.errorCode && response.data.errorCode.trim() === '0') resolve();
          else reject();
        })
        .catch(() => reject());
    });

  useEffect(() => {
    if (!availableHTML) {
      /* istanbul ignore next */
      doesTheClientHasOnlineCurse()
        .then(() => {
          Axios.get(htmlURL, {
            timeout: 30000,
            headers: {
              Accept: 'text/html',
            },
          }).then(() => {
            isTheHTMLAvailable(true);
            sessionStorage.setItem('isCurseOnline', true);
            callback();
          });
        })
        .catch(() => {
          isTheHTMLAvailable(false);
          sessionStorage.setItem('isCurseOnline', false);
          callback();
        });
    }
  }, []);
  return (
    <React.Fragment>
      {availableHTML && (
        <Margin side={'top'} xs={24} md={24}>
          <OnlineCourseContainer htmlEnabled={availableHTML}>
            <Iframe
              url={htmlURL}
              id={`online-course-iframe`}
              width="100%"
              height="100%"
              scrolling="no"
              styles={{ border: 'none' }}
            />
          </OnlineCourseContainer>
        </Margin>
      )}
    </React.Fragment>
  );
};

OnlineCourse.propTypes = {
  htmlURL: PropTypes.string.isRequired,
};
